export class AtsTrackingHelper {
    public static publishEvent(eventData: IECommerceEventData): void {
        if (window.shell) {
            window.shell.subscribeTo('kraken.rdy', (payload) => {
                if(!payload || payload === false) return;

                const dateNow: string = new Date().toISOString();

                window.shell.publishTo('kraken.categoryviewed', {
                    'version': 1,
                    'eventDate': dateNow,
                    'context': {
                        'senderId': 'ESPP1.ArticleTile.Service'
                    },
                    'type': ECommerceEvent.CategoryViewed,
                    'properties': {
                        'category': eventData.navigationKey
                    }
                });
            }, 'ATS.publishCategoryViewedEvent');
        }
    }

    public static publishSearchResultEvent(eventData: ISearchResultEventData): void {
        if (window.shell) {
            window.shell.subscribeTo('kraken.rdy', (payload) => {
                if(!payload || payload === false) return;

                const dateNow: string = new Date().toISOString();

                window.shell.publishTo('kraken.searchresults', {
                    'version': 1,
                    'eventDate': dateNow,
                    'context': {
                        'senderId': 'ESPP1.ArticleTile.Service'
                    },
                    'type': ECommerceEvent.SearchResults,
                    'properties': eventData
                });
            }, 'ATS.publishSearchResultEvent');
        }
    }
}

export enum ECommerceEvent {
    CategoryViewed = 'CategoryViewed',
    SearchResults = 'SearchResults'
}

export interface IECommerceEventData {
    'navigationKey': string;
}

export interface ISearchResultEventData {
    contents: ISearchResultEventItem[];
    value: number;
    currency: string;
    searchTerm: string;
    searchPageType: string;
    searchCount: number;
}

export interface ISearchResultEventItem {
    id: string;
    type: string;
    name: string;
    category: string;
    numItems: number;
    value: string;
}